import Loadable from "react-loadable";
import Loading from "../views/components/shared/Loading";

import LogOut from "../views/pages/LogOut";
import NotFound from "../views/pages/NotFound";
import About from "../views/pages/About";

const AsyncSignIn = Loadable({
    loader: () => import("../views/pages/SignIn"),
    loading: Loading
  }),
  AsyncVerification = Loadable({
    loader: () => import("../views/pages/Verification"),
    loading: Loading
  }),
  AsyncUnregisterVerification = Loadable({
    loader: () => import("../views/pages/UnregisterVerification"),
    loading: Loading
  }),
  AsyncCSOLogin = Loadable({
    loader: () => import("../views/pages/CSOLogin"),
    loading: Loading
  }),
  AsyncSignUp = Loadable({
    loader: () => import("../views/pages/SignUp"),
    loading: Loading
  }),
  AsyncForgotPassword = Loadable({
    loader: () => import("../views/pages/ForgotPassword"),
    loading: Loading
  }),
  AsyncUnRegister = Loadable({
    loader: () => import("../views/pages/UnRegister"),
    loading: Loading
  }),
  AsyncAccount = Loadable({
    loader: () => import("../views/pages/Account"),
    loading: Loading
  }),
  AsyncContactUs = Loadable({
    loader: () => import("../views/pages/ContactUs"),
    loading: Loading
  }),
  AsyncTransactions = Loadable({
    loader: () => import("../views/pages/CardTransactions"),
    loading: Loading
  }),
  AsyncRewards = Loadable({
    loader: () => import("../views/pages/Rewards"),
    loading: Loading
  }),
  AsyncRewardList = Loadable({
    loader: () => import("../views/pages/Dashboard"),
    loading: Loading
  }),
  AsyncRewardsCatalogue = Loadable({
    loader: () => import("../views/pages/RewardsCatalogue"),
    loading: Loading
  }),
  AsyncInviteFriends = Loadable({
    loader: () => import("../views/pages/InviteFriends"),
    loading: Loading
  }),
  AsyncProfile = Loadable({
    loader: () => import("../views/pages/Profile"),
    loading: Loading
  }),
  AsyncCards = Loadable({
    loader: () => import("../views/pages/Cards"),
    loading: Loading
  }),
  AsyncCardDetails = Loadable({
    loader: () => import("../views/pages/CardDetails"),
    loading: Loading
  }),
  AsyncAddCard = Loadable({
    loader: () => import("../views/pages/AddCard"),
    loading: Loading
  }),
  AsyncChangePassword = Loadable({
    loader: () => import("../views/pages/ChangePassword"),
    loading: Loading
  }),
  AsyncTransactionDetails = Loadable({
    loader: () => import("../views/pages/TransactionDetails"),
    loading: Loading
  }),
  AsyncResetPassword = Loadable({
    loader: () => import("../views/pages/ResetPassword"),
    loading: Loading
  }),
  AsyncTransferBalance = Loadable({
    loader: () => import("../views/pages/TransferBalance"),
    loading: Loading
  }),
  AsyncReportLossPage = Loadable({
    loader: () => import("../views/pages/ReportLoss"),
    loading: Loading
  }),
  AsyncVerifyGoldCardAddressPage = Loadable({
    loader: () => import("../views/pages/VerifyGoldCardAddress"),
    loading: Loading
  }),
  AsyncProductDetail = Loadable({
    loader: () => import("../views/pages/ProductDetail"),
    loading: Loading
  }),
  AsyncLanding = Loadable({
    loader: () => import("../views/pages/Landing"),
    loading: Loading
  }),
  AsyncFaq = Loadable({
    loader: () => import("../views/pages/Faq"),
    loading: Loading
  });

const localeRegex = ":locale(en|vi)?";

const Routes = [
  {
    path: `/landing`,
    isPrivate: false,
    component: AsyncLanding
  },
  {
    path: `/sign-in`,
    isPrivate: false,
    component: AsyncSignIn
  },
  {
    path: `/cards`,
    isPrivate: false,
    component: AsyncCards
  },
  {
    path: `/sign-up`,
    isPrivate: false,
    component: AsyncSignUp
  },
  {
    path: `/forgot-password`,
    isPrivate: false,
    component: AsyncForgotPassword
  },
  {
    path: `/reset-password/:mid/:ts`,
    isPrivate: false,
    component: AsyncResetPassword
  },
  {
    path: `/verification/:mid/:cn/:ts`,
    isPrivate: false,
    component: AsyncVerification
  },
  {
    path: `/unregisterVerification/:mid/:cn`,
    isPrivate: false,
    component: AsyncUnregisterVerification
  },
  {
    path: `/csologin/:Param`,
    isPrivate: false,
    component: AsyncCSOLogin
  }
];

const PrivateRoutes = [
  {
    path: `/account`,
    isPrivate: true,
    component: AsyncAccount
  },
  // {
  // 	path: `/unregister`,
  // 	isPrivate: true,
  // 	component: AsyncUnRegister,
  // },
  {
    path: `/contact-us`,
    isPrivate: true,
    component: AsyncContactUs
  },
  {
    path: `/transactions`,
    isPrivate: true,
    exact: true,
    component: AsyncTransactions
  },
  {
    path: `/transactions/:cardNo`,
    isPrivate: true,
    exact: true,
    component: AsyncTransactions
  },
  {
    path: `/transactions/:receiptNo/:autoID`,
    isPrivate: true,
    component: AsyncTransactionDetails
  },
  {
    path: `/cards`,
    isPrivate: true,
    exact: true,
    component: AsyncCards
  },
  {
    path: `/cards/transfer/:cardNo`,
    isPrivate: true,
    component: AsyncTransferBalance
  },
  {
    path: `/cards/add-card`,
    isPrivate: true,
    component: AsyncAddCard
  },
  {
    path: `/cards/report-loss/:cardNo`,
    isPrivate: true,
    component: AsyncReportLossPage
  },
  {
    path: `/cards/verify-gold-card-address`,
    isPrivate: true,
    component: AsyncVerifyGoldCardAddressPage
  },
  {
    path: `/cards/:cardNo`,
    isPrivate: true,
    component: AsyncCardDetails
  },
  {
    path: `/rewards`,
    isPrivate: true,
    component: AsyncRewards
  },
  {
    path: `/dashboard`,
    isPrivate: true,
    component: AsyncRewardList
  },
  {
    path: `/rewards-catalogue`,
    isPrivate: true,
    component: AsyncRewardsCatalogue
  },
  {
    path: `/invite-friends`,
    isPrivate: true,
    component: AsyncInviteFriends
  },
  {
    path: `/profile`,
    isPrivate: true,
    exact: true,
    component: AsyncProfile
  },
  {
    path: `/profile/change-password`,
    isPrivate: true,
    component: AsyncChangePassword
  },
  {
    path: `/profile/reset-password`,
    isPrivate: true,
    component: AsyncResetPassword
  },
  {
    path: `/about`,
    isPrivate: true,
    component: About
  },
  {
    path: `/product-detail`,
    isPrivate: true,
    component: AsyncProductDetail
  },
  {
    path: `/faq`,
    isPrivate: true,
    component: AsyncFaq
  }
];

const SharedRoutes = [
  {
    path: `/logout`,
    isPrivate: true,
    component: LogOut
  },
  {
    path: `/`,
    exact: true,
    isPrivate: false,
    component: AsyncSignIn
  },
  {
    path: `/*`,
    isPrivate: false,
    status: 404,
    component: NotFound
  }
];

export { Routes, PrivateRoutes, SharedRoutes, localeRegex };



// WEBPACK FOOTER //
// ./src/configs/Routes.js